// src/components/games/pipsWordPuzzle/wordlist.ts
// Valid words for Pip's Word Puzzle guesses - includes common 3-7 letter English words

// Common 5-letter words (most common for Pip's Word Puzzle)
// NOTE: This includes all words from the nerdle_puzzles table plus common English words
const FIVE_LETTER_WORDS = new Set([
  // Gaming and tabletop-specific 5-letter terms (from puzzles)
  'BLUFF', 'ROUGE', 'JOKER', 'CLANK', 'TROVE', 'GLOOM', 'BRASS', 'TERRA',
  'AZUL', 'EVOKE', 'CATAN', 'CODEX', 'HOARD', 'FORGE', 'ROGUE', 'HEIST',
  'CAPER', 'QUEST', 'CRYPT', 'MANOR', 'ELDER', 'DREAD', 'REALM', 'CHAOS',
  'SPIRE', 'TOKEN', 'MINIS', 'TILES', 'CUBES', 'TRACK', 'BOARD', 'CARDS',
  'CHESS', 'RULES', 'SPELL', 'STONE', 'SWORD', 'TOWER', 'TRADE', 'WANDS',
  'WITCH', 'DRAFT', 'DECKS', 'PHASE', 'SHIFT', 'BLITZ', 'LORDS', 'KINGS',
  // Standard English 5-letter words
  'ABOUT', 'ABOVE', 'ABUSE', 'ACTOR', 'ACUTE', 'ADMIT', 'ADOPT', 'ADULT', 'AFTER', 'AGAIN',
  'AGENT', 'AGREE', 'AHEAD', 'ALARM', 'ALBUM', 'ALERT', 'ALIGN', 'ALIVE', 'ALLOW', 'ALONE',
  'ALONG', 'ALTER', 'ANGEL', 'ANGER', 'ANGLE', 'ANGRY', 'APART', 'APPLE', 'APPLY', 'ARENA',
  'ARGUE', 'ARISE', 'ARRAY', 'ASIDE', 'ASSET', 'AUDIO', 'AVOID', 'AWAKE', 'AWARD', 'AWARE',
  'BADLY', 'BAKER', 'BASES', 'BASIC', 'BASIS', 'BEACH', 'BEGAN', 'BEGIN', 'BEGUN', 'BEING',
  'BELOW', 'BENCH', 'BILLY', 'BIRTH', 'BLACK', 'BLAME', 'BLIND', 'BLOCK', 'BLOOD', 'BOARD',
  'BOOST', 'BOOTH', 'BOUND', 'BRAIN', 'BRAND', 'BREAD', 'BREAK', 'BREED', 'BRIEF', 'BRING',
  'BROAD', 'BROKE', 'BROWN', 'BUILD', 'BUILT', 'BUYER', 'CABLE', 'CALIF', 'CARRY', 'CATCH',
  'CAUSE', 'CHAIN', 'CHAIR', 'CHART', 'CHASE', 'CHEAP', 'CHECK', 'CHEST', 'CHIEF', 'CHILD',
  'CHINA', 'CHOSE', 'CIVIL', 'CLAIM', 'CLASS', 'CLEAN', 'CLEAR', 'CLICK', 'CLOCK', 'CLOSE',
  'COACH', 'COAST', 'COULD', 'COUNT', 'COURT', 'COVER', 'CRAFT', 'CRASH', 'CRAZY', 'CREAM',
  'CRIME', 'CROSS', 'CROWD', 'CROWN', 'CRUDE', 'CYCLE', 'DAILY', 'DANCE', 'DATED', 'DEALT',
  'DEATH', 'DEBUT', 'DELAY', 'DEPTH', 'DOING', 'DOUBT', 'DOZEN', 'DRAFT', 'DRAMA', 'DRANK',
  'DRAWN', 'DREAM', 'DRESS', 'DRILL', 'DRINK', 'DRIVE', 'DROVE', 'DYING', 'EAGER', 'EARLY',
  'EARTH', 'EIGHT', 'ELITE', 'EMPTY', 'ENEMY', 'ENJOY', 'ENTER', 'ENTRY', 'EQUAL', 'ERROR',
  'EVENT', 'EVERY', 'EXACT', 'EXIST', 'EXTRA', 'FAITH', 'FALSE', 'FAULT', 'FIBER', 'FIELD',
  'FIFTH', 'FIFTY', 'FIGHT', 'FINAL', 'FIRST', 'FIXED', 'FLASH', 'FLEET', 'FLOOR', 'FLUID',
  'FOCUS', 'FORCE', 'FORTH', 'FORTY', 'FORUM', 'FOUND', 'FRAME', 'FRANK', 'FRAUD', 'FRESH',
  'FRONT', 'FRUIT', 'FULLY', 'FUNNY', 'GIANT', 'GIVEN', 'GLASS', 'GLOBE', 'GOING', 'GRACE',
  'GRADE', 'GRAND', 'GRANT', 'GRASS', 'GREAT', 'GREEN', 'GROSS', 'GROUP', 'GROWN', 'GUARD',
  'GUESS', 'GUEST', 'GUIDE', 'HAPPY', 'HARRY', 'HEART', 'HEAVY', 'HENCE', 'HENRY', 'HORSE',
  'HOTEL', 'HOUSE', 'HUMAN', 'IDEAL', 'IMAGE', 'INDEX', 'INNER', 'INPUT', 'ISSUE', 'JAPAN',
  'JIMMY', 'JOINT', 'JONES', 'JUDGE', 'KNOWN', 'LABEL', 'LARGE', 'LASER', 'LATER', 'LAUGH',
  'LAYER', 'LEARN', 'LEAST', 'LEAVE', 'LEGAL', 'LEMON', 'LEVEL', 'LEWIS', 'LIGHT', 'LIMIT',
  'LINKS', 'LIVES', 'LOCAL', 'LOGIC', 'LOOSE', 'LOWER', 'LUCKY', 'LUNCH', 'LYING', 'MAGIC',
  'MAJOR', 'MAKER', 'MARCH', 'MARIA', 'MATCH', 'MAYBE', 'MAYOR', 'MEANT', 'MEDIA', 'METAL',
  'MIGHT', 'MINOR', 'MINUS', 'MIXED', 'MODEL', 'MONEY', 'MONTH', 'MORAL', 'MOTOR', 'MOUNT',
  'MOUSE', 'MOUTH', 'MOVIE', 'MUSIC', 'NEEDS', 'NEVER', 'NEWLY', 'NIGHT', 'NOISE', 'NORTH',
  'NOTED', 'NOVEL', 'NURSE', 'OCCUR', 'OCEAN', 'OFFER', 'OFTEN', 'ORDER', 'OTHER', 'OUGHT',
  'PAINT', 'PANEL', 'PANIC', 'PAPER', 'PARTY', 'PEACE', 'PETER', 'PHASE', 'PHONE', 'PHOTO',
  'PIECE', 'PILOT', 'PITCH', 'PLACE', 'PLAIN', 'PLANE', 'PLANT', 'PLATE', 'POINT', 'POUND',
  'POWER', 'PRESS', 'PRICE', 'PRIDE', 'PRIME', 'PRINT', 'PRIOR', 'PRIZE', 'PROOF', 'PROUD',
  'PROVE', 'QUEEN', 'QUICK', 'QUIET', 'QUITE', 'RADIO', 'RAISE', 'RANGE', 'RAPID', 'RATIO',
  'REACH', 'READY', 'REFER', 'RIGHT', 'RIVAL', 'RIVER', 'ROBIN', 'ROGER', 'ROMAN', 'ROUGH',
  'ROUND', 'ROUTE', 'ROYAL', 'RURAL', 'SCALE', 'SCENE', 'SCOPE', 'SCORE', 'SENSE', 'SERVE',
  'SEVEN', 'SHALL', 'SHAPE', 'SHARE', 'SHARP', 'SHEET', 'SHELF', 'SHELL', 'SHIFT', 'SHINE',
  'SHIRT', 'SHOCK', 'SHOOT', 'SHORT', 'SHOWN', 'SIGHT', 'SINCE', 'SIXTH', 'SIXTY', 'SIZED',
  'SKILL', 'SLEEP', 'SLIDE', 'SMALL', 'SMART', 'SMILE', 'SMITH', 'SMOKE', 'SOLID', 'SOLVE',
  'SORRY', 'SOUND', 'SOUTH', 'SPACE', 'SPARE', 'SPEAK', 'SPEED', 'SPEND', 'SPENT', 'SPLIT',
  'SPOKE', 'SPORT', 'STAFF', 'STAGE', 'STAKE', 'STAND', 'START', 'STATE', 'STEAM', 'STEEL',
  'STICK', 'STILL', 'STOCK', 'STONE', 'STOOD', 'STORE', 'STORM', 'STORY', 'STRIP', 'STUCK',
  'STUDY', 'STUFF', 'STYLE', 'SUGAR', 'SUITE', 'SUPER', 'SWEET', 'TABLE', 'TAKEN', 'TASTE',
  'TAXES', 'TEACH', 'TEETH', 'TERRY', 'TEXAS', 'THANK', 'THEFT', 'THEIR', 'THEME', 'THERE',
  'THESE', 'THICK', 'THING', 'THINK', 'THIRD', 'THOSE', 'THREE', 'THREW', 'THROW', 'TIGHT',
  'TIMES', 'TITLE', 'TODAY', 'TOPIC', 'TOTAL', 'TOUCH', 'TOUGH', 'TOWER', 'TRACK', 'TRADE',
  'TRAIN', 'TREAT', 'TREND', 'TRIAL', 'TRIBE', 'TRICK', 'TRIED', 'TRIES', 'TROOP', 'TRUCK',
  'TRULY', 'TRUNK', 'TRUST', 'TRUTH', 'TWICE', 'UNDER', 'UNDUE', 'UNION', 'UNITY', 'UNTIL',
  'UPPER', 'UPSET', 'URBAN', 'USAGE', 'USUAL', 'VALID', 'VALUE', 'VIDEO', 'VIRUS', 'VISIT',
  'VITAL', 'VOCAL', 'VOICE', 'WASTE', 'WATCH', 'WATER', 'WHEEL', 'WHERE', 'WHICH', 'WHILE',
  'WHITE', 'WHOLE', 'WHOSE', 'WOMAN', 'WOMEN', 'WORLD', 'WORRY', 'WORSE', 'WORST', 'WORTH',
  'WOULD', 'WOUND', 'WRITE', 'WRONG', 'WROTE', 'YOUNG', 'YOUTH', 'ZONES',
  // Gaming-specific words
  'BOARD', 'CARDS', 'CHESS', 'DICE', 'GAMES', 'MAGIC', 'PIECE', 'POKER', 'QUEST', 'RULES',
  'SPELL', 'STONE', 'SWORD', 'TOKEN', 'TOWER', 'TRADE', 'WANDS', 'WITCH', 'WIZARD',
]);

// Common 4-letter words
const FOUR_LETTER_WORDS = new Set([
  'ABLE', 'AGED', 'ALSO', 'AREA', 'ARMY', 'AWAY', 'BABY', 'BACK', 'BALL', 'BAND',
  'BANK', 'BASE', 'BATH', 'BEAR', 'BEAT', 'BEEN', 'BEER', 'BELL', 'BELT', 'BEST',
  'BILL', 'BIRD', 'BLOW', 'BLUE', 'BOAT', 'BODY', 'BOMB', 'BOND', 'BONE', 'BOOK',
  'BOOM', 'BORN', 'BOSS', 'BOTH', 'BOWL', 'BULK', 'BURN', 'BUSH', 'BUSY', 'CALL',
  'CALM', 'CAME', 'CAMP', 'CARD', 'CARE', 'CASE', 'CASH', 'CAST', 'CELL', 'CHAT',
  'CHIP', 'CITY', 'CLUB', 'COAL', 'COAT', 'CODE', 'COLD', 'COME', 'COOK', 'COOL',
  'COPE', 'COPY', 'CORE', 'COST', 'CREW', 'CROP', 'DARK', 'DATA', 'DATE', 'DAWN',
  'DAYS', 'DEAD', 'DEAL', 'DEAN', 'DEAR', 'DEBT', 'DEEP', 'DENY', 'DESK', 'DIAL',
  'DICK', 'DIET', 'DISC', 'DISK', 'DOES', 'DONE', 'DOOR', 'DOSE', 'DOWN', 'DRAW',
  'DREW', 'DROP', 'DRUG', 'DUAL', 'DUKE', 'DULL', 'DUST', 'DUTY', 'EACH', 'EARN',
  'EASE', 'EAST', 'EASY', 'EDGE', 'ELSE', 'EVEN', 'EVER', 'EVIL', 'EXIT', 'FACE',
  'FACT', 'FAIL', 'FAIR', 'FALL', 'FARM', 'FAST', 'FATE', 'FEAR', 'FEED', 'FEEL',
  'FEET', 'FELL', 'FELT', 'FILE', 'FILL', 'FILM', 'FIND', 'FINE', 'FIRE', 'FIRM',
  'FISH', 'FIVE', 'FLAT', 'FLOW', 'FOOD', 'FOOT', 'FORD', 'FORM', 'FORT', 'FOUR',
  'FREE', 'FROM', 'FUEL', 'FULL', 'FUND', 'GAIN', 'GAME', 'GATE', 'GAVE', 'GEAR',
  'GENE', 'GIFT', 'GIRL', 'GIVE', 'GLAD', 'GOAL', 'GOES', 'GOLD', 'GOLF', 'GONE',
  'GOOD', 'GRAY', 'GREW', 'GREY', 'GROW', 'GULF', 'HAIR', 'HALF', 'HALL', 'HAND',
  'HANG', 'HARD', 'HARM', 'HATE', 'HAVE', 'HEAD', 'HEAR', 'HEAT', 'HELD', 'HELL',
  'HELP', 'HERE', 'HERO', 'HIGH', 'HILL', 'HIRE', 'HOLD', 'HOLE', 'HOLY', 'HOME',
  'HOPE', 'HOST', 'HOUR', 'HUGE', 'HUNG', 'HUNT', 'HURT', 'IDEA', 'INCH', 'INTO',
  'IRON', 'ITEM', 'JACK', 'JANE', 'JEAN', 'JOHN', 'JOIN', 'JUMP', 'JURY', 'JUST',
  'KEEN', 'KEEP', 'KENT', 'KEPT', 'KICK', 'KILL', 'KIND', 'KING', 'KNEE', 'KNEW',
  'KNOW', 'LACK', 'LADY', 'LAID', 'LAKE', 'LAND', 'LANE', 'LAST', 'LATE', 'LEAD',
  'LEFT', 'LESS', 'LIFE', 'LIFT', 'LIKE', 'LINE', 'LINK', 'LIST', 'LIVE', 'LOAD',
  'LOAN', 'LOCK', 'LONE', 'LONG', 'LOOK', 'LORD', 'LOSE', 'LOSS', 'LOST', 'LOTS',
  'LOUD', 'LOVE', 'LUCK', 'MADE', 'MAIL', 'MAIN', 'MAKE', 'MALE', 'MALL', 'MANY',
  'MARE', 'MARK', 'MARS', 'MARY', 'MASS', 'MATE', 'MATH', 'MEAL', 'MEAN', 'MEAT',
  'MEET', 'MENU', 'MERE', 'MESS', 'MICE', 'MILE', 'MILK', 'MILL', 'MIND', 'MINE',
  'MISS', 'MODE', 'MONK', 'MOOD', 'MOON', 'MORE', 'MOST', 'MOVE', 'MUCH', 'MUST', 'MYTH',
  'NAME', 'NAVY', 'NEAR', 'NECK', 'NEED', 'NEWS', 'NEXT', 'NICE', 'NICK', 'NINE',
  'NONE', 'NOON', 'NORM', 'NOSE', 'NOTE', 'OKAY', 'ONCE', 'ONES', 'ONLY', 'ONTO',
  'OPEN', 'ORAL', 'OVER', 'PACE', 'PACK', 'PAGE', 'PAID', 'PAIN', 'PAIR', 'PALE',
  'PALM', 'PARK', 'PART', 'PASS', 'PAST', 'PATH', 'PAUL', 'PEAK', 'PETE', 'PICK',
  'PILE', 'PINE', 'PINK', 'PIPE', 'PLAN', 'PLAY', 'PLOT', 'PLUG', 'PLUS', 'POET',
  'POLE', 'POLL', 'POND', 'POOL', 'POOR', 'POPE', 'PORK', 'PORT', 'POST', 'POUR',
  'PULL', 'PURE', 'PUSH', 'QUIT', 'RACE', 'RAIL', 'RAIN', 'RANK', 'RARE', 'RATE',
  'READ', 'REAL', 'REAR', 'RELY', 'RENT', 'REST', 'RICE', 'RICH', 'RIDE', 'RING',
  'RISE', 'RISK', 'ROAD', 'ROCK', 'ROLE', 'ROLL', 'ROOF', 'ROOM', 'ROOT', 'ROPE',
  'ROSE', 'RULE', 'RUSH', 'RUTH', 'SAFE', 'SAID', 'SAKE', 'SALE', 'SALT', 'SAME',
  'SAND', 'SAVE', 'SEAT', 'SEED', 'SEEK', 'SEEM', 'SEEN', 'SELF', 'SELL', 'SEND',
  'SENT', 'SEPT', 'SHIP', 'SHOP', 'SHOT', 'SHOW', 'SHUT', 'SICK', 'SIDE', 'SIGN',
  'SITE', 'SIZE', 'SKIN', 'SLIP', 'SLOW', 'SNOW', 'SOFT', 'SOIL', 'SOLD', 'SOLE',
  'SOME', 'SONG', 'SOON', 'SORT', 'SOUL', 'SPOT', 'STAR', 'STAY', 'STEM', 'STEP',
  'STOP', 'SUCH', 'SUIT', 'SURE', 'TAKE', 'TALE', 'TALK', 'TALL', 'TANK', 'TAPE',
  'TASK', 'TEAM', 'TEAR', 'TECH', 'TELL', 'TEND', 'TERM', 'TEST', 'TEXT', 'THAN',
  'THAT', 'THEM', 'THEN', 'THEY', 'THIN', 'THIS', 'THUS', 'TILL', 'TIME', 'TINY',
  'TOLD', 'TOLL', 'TONE', 'TONY', 'TOOK', 'TOOL', 'TORN', 'TOUR', 'TOWN', 'TRIP',
  'TRUE', 'TUNE', 'TURN', 'TWIN', 'TYPE', 'UNIT', 'UPON', 'USED', 'USER', 'VARY',
  'VAST', 'VERY', 'VICE', 'VIEW', 'VOTE', 'WAGE', 'WAIT', 'WAKE', 'WALK', 'WALL',
  'WANT', 'WARD', 'WARM', 'WARN', 'WASH', 'WAVE', 'WAYS', 'WEAK', 'WEAR', 'WEEK',
  'WELL', 'WENT', 'WERE', 'WEST', 'WHAT', 'WHEN', 'WHOM', 'WIDE', 'WIFE', 'WILD',
  'WILL', 'WIND', 'WINE', 'WING', 'WIRE', 'WISE', 'WISH', 'WITH', 'WOOD', 'WORD',
  'WORE', 'WORK', 'WORM', 'WORN', 'YARD', 'YEAH', 'YEAR', 'YORK', 'YOUR', 'ZERO',
  'ZONE',
  // Gaming terms
  'CARD', 'DICE', 'GAME', 'MOVE', 'PAWN', 'PLAY', 'ROLL', 'ROOK', 'RULE', 'TURN',
]);

// Common 6-letter words
const SIX_LETTER_WORDS = new Set([
  'ACCEPT', 'ACCESS', 'ACROSS', 'ACTION', 'ACTIVE', 'ACTUAL', 'ADVICE', 'ADVISE', 'AFFECT', 'AFFORD',
  'AFRAID', 'AGENCY', 'AGENDA', 'ALMOST', 'ALWAYS', 'AMOUNT', 'ANIMAL', 'ANNUAL', 'ANSWER', 'ANYONE',
  'ANYWAY', 'APPEAL', 'APPEAR', 'AROUND', 'ARRIVE', 'ARTIST', 'ASPECT', 'ASSESS', 'ASSIGN', 'ASSIST',
  'ASSUME', 'ASSURE', 'ATTACH', 'ATTACK', 'ATTEND', 'AUGUST', 'AUTHOR', 'AVENUE', 'BACKED', 'BARELY',
  'BATTLE', 'BEAUTY', 'BECAME', 'BECOME', 'BEFORE', 'BEGAN', 'BEHALF', 'BEHAVE', 'BEHIND', 'BELIEF',
  'BELONG', 'BERLIN', 'BETTER', 'BEYOND', 'BISHOP', 'BORDER', 'BOTTLE', 'BOTTOM', 'BOUGHT', 'BRANCH',
  'BREACH', 'BREAST', 'BREATH', 'BRIDGE', 'BRIGHT', 'BRING', 'BROKEN', 'BUDGET', 'BURDEN', 'BUREAU',
  'BUTTON', 'CAMERA', 'CANCER', 'CANNOT', 'CARBON', 'CAREER', 'CASTLE', 'CASUAL', 'CAUGHT', 'CENTER',
  'CENTRE', 'CHANCE', 'CHANGE', 'CHARGE', 'CHOICE', 'CHOOSE', 'CHOSEN', 'CHURCH', 'CIRCLE', 'CLIENT',
  'CLOSED', 'CLOSER', 'COFFEE', 'COLUMN', 'COMBAT', 'COMING', 'COMMON', 'COMPLY', 'COPPER', 'CORNER',
  'COSTLY', 'COUNTY', 'COUPLE', 'COURSE', 'COVERS', 'CREATE', 'CREDIT', 'CRISIS', 'CUSTOM', 'DAMAGE',
  'DANGER', 'DEALER', 'DEBATE', 'DECADE', 'DECIDE', 'DEFEAT', 'DEFEND', 'DEFINE', 'DEGREE', 'DEMAND',
  'DEPEND', 'DEPUTY', 'DESERT', 'DESIGN', 'DESIRE', 'DETAIL', 'DETECT', 'DEVICE', 'DIFFER', 'DINNER',
  'DIRECT', 'DIVIDE', 'DOCTOR', 'DOLLAR', 'DOMAIN', 'DOUBLE', 'DRIVEN', 'DRIVER', 'DURING', 'EASILY',
  'EATING', 'EDITOR', 'EFFECT', 'EFFORT', 'EIGHTH', 'EITHER', 'ELEVEN', 'EMERGE', 'EMPIRE', 'EMPLOY',
  'ENABLE', 'ENDING', 'ENERGY', 'ENGAGE', 'ENGINE', 'ENOUGH', 'ENSURE', 'ENTIRE', 'ENTITY', 'EQUITY',
  'ESCAPE', 'ESTATE', 'ETHNIC', 'EUROPE', 'EVENTS', 'EXCEED', 'EXCEPT', 'EXCESS', 'EXPAND', 'EXPECT',
  'EXPERT', 'EXPORT', 'EXPOSE', 'EXTENT', 'FABRIC', 'FACING', 'FACTOR', 'FAILED', 'FAIRLY', 'FALLEN',
  'FAMILY', 'FAMOUS', 'FATHER', 'FELLOW', 'FEMALE', 'FIGURE', 'FILING', 'FINGER', 'FINISH', 'FISCAL',
  'FLIGHT', 'FLYING', 'FOLLOW', 'FORCED', 'FOREST', 'FORGET', 'FORMAL', 'FORMAT', 'FORMER', 'FOSTER',
  'FOUGHT', 'FOURTH', 'FRANCE', 'FRENCH', 'FRIEND', 'FUTURE', 'GARDEN', 'GATHER', 'GENDER', 'GENERAL',
  'GERMAN', 'GLOBAL', 'GOLDEN', 'GORDON', 'GOSPEL', 'GOTTEN', 'GROUND', 'GROWTH', 'GUILTY', 'HANDED',
  'HANDLE', 'HAPPEN', 'HARDLY', 'HATRED', 'HEADED', 'HEALTH', 'HEARTS', 'HEAVEN', 'HEIGHT', 'HIDDEN',
  'HIGHLY', 'HINT', 'HOLDER', 'HONEST', 'HORROR', 'HORSES', 'HOSPITAL', 'HUNGER', 'HUNTER', 'IMPACT',
  'IMPORT', 'IMPOSE', 'INCOME', 'INDEED', 'INJURY', 'INSIDE', 'INTEND', 'INTENT', 'INVEST', 'ISLAND',
  'ITSELF', 'JERSEY', 'JOSEPH', 'JUNIOR', 'KILLED', 'KNIGHT', 'LABOUR', 'LATELY', 'LATEST', 'LATTER',
  'LAUNCH', 'LAWYER', 'LEADER', 'LEAGUE', 'LEAVES', 'LENGTH', 'LESSON', 'LETTER', 'LIGHTS', 'LIKELY',
  'LINKED', 'LIQUID', 'LISTEN', 'LITTLE', 'LIVING', 'LOADED', 'LOCATE', 'LOCKED', 'LONDON', 'LOSING',
  'LOVELY', 'LOVING', 'LUXURY', 'MAINLY', 'MAKING', 'MANAGE', 'MANNER', 'MANUAL', 'MARGIN', 'MARINE',
  'MARKED', 'MARKET', 'MARTIN', 'MASTER', 'MATTER', 'MATURE', 'MEMBER', 'MEMORY', 'MENTAL', 'MERELY',
  'MERGER', 'METHOD', 'MIDDLE', 'MILLER', 'MINING', 'MINUTE', 'MIRROR', 'MOBILE', 'MODERN', 'MODEST',
  'MODULE', 'MOMENT', 'MORRIS', 'MOSCOW', 'MOSTLY', 'MOTHER', 'MOTION', 'MOVING', 'MURDER', 'MUSEUM',
  'MUTUAL', 'MYSELF', 'NARROW', 'NATION', 'NATIVE', 'NATURE', 'NEARBY', 'NEARLY', 'NEURAL', 'NOBODY',
  'NORMAL', 'NOTICE', 'NOTION', 'NUMBER', 'OBJECT', 'OBTAIN', 'OFFICE', 'OFFICER', 'ONLINE', 'OPTION',
  'ORANGE', 'ORIGIN', 'OUTPUT', 'OXFORD', 'PACKED', 'PALACE', 'PARENT', 'PARTLY', 'PASSED', 'PATENT',
  'PAYING', 'PEOPLE', 'PERIOD', 'PERMIT', 'PERSON', 'PICKED', 'PLANET', 'PLAYER', 'PLEASE', 'PLENTY',
  'POCKET', 'POETRY', 'POLICE', 'POLICY', 'POLITICS', 'PORTAL', 'POSTED', 'POTATO', 'POVERTY', 'POWDER',
  'PRAISE', 'PRAYER', 'PREFER', 'PRETTY', 'PRINCE', 'PRISON', 'PROFIT', 'PROPER', 'PROVEN', 'PUBLIC',
  'PULLED', 'PURSUE', 'PUSHED', 'PUZZLE', 'QUOTED', 'RACIAL', 'RAISED', 'RANDOM', 'RARELY', 'RATHER',
  'RATING', 'READER', 'REALLY', 'REASON', 'RECALL', 'RECENT', 'RECORD', 'REDUCE', 'REFORM', 'REFUGE',
  'REFUSE', 'REGARD', 'REGIME', 'REGION', 'RELATE', 'RELIEF', 'REMAIN', 'REMARK', 'REMOVE', 'REPAIR',
  'REPEAT', 'REPLACE', 'REPORT', 'RESCUE', 'RESIST', 'RESORT', 'RESULT', 'RETAIN', 'RETIRE', 'RETURN',
  'REVEAL', 'REVIEW', 'REWARD', 'RIDING', 'RISING', 'RITUAL', 'ROCKET', 'ROLLED', 'RULING', 'RUNNING',
  'RUSSIA', 'SACRED', 'SAFELY', 'SAFETY', 'SALARY', 'SAMPLE', 'SAVING', 'SAYING', 'SCHEME', 'SCHOOL',
  'SCREEN', 'SCRIPT', 'SEARCH', 'SEASON', 'SECOND', 'SECRET', 'SECTOR', 'SECURE', 'SEEING', 'SEEKING',
  'SELECT', 'SELLER', 'SENIOR', 'SERIES', 'SERVED', 'SERVER', 'SETTLE', 'SEVERE', 'SEXUAL', 'SHADOW',
  'SHARED', 'SHIELD', 'SHOULD', 'SHOWED', 'SHOWER', 'SIGNAL', 'SIGNED', 'SILENT', 'SILVER', 'SIMILAR',
  'SIMPLE', 'SIMPLY', 'SINGLE', 'SISTER', 'SLIGHT', 'SMOOTH', 'SOCIAL', 'SOLELY', 'SOUGHT', 'SOURCE',
  'SOVIET', 'SPEAKER', 'SPEECH', 'SPIRIT', 'SPOKE', 'SPORTS', 'SPREAD', 'SPRING', 'SQUARE', 'STABLE',
  'STAGES', 'STANDS', 'STATED', 'STATES', 'STATUS', 'STEADY', 'STOLEN', 'STORED', 'STRAIN', 'STREAM',
  'STREET', 'STRESS', 'STRICT', 'STRIKE', 'STRING', 'STRONG', 'STRUCK', 'STUDIO', 'SUBMIT', 'SUBTLE',
  'SUDDEN', 'SUFFER', 'SUMMER', 'SUMMIT', 'SUPPLY', 'SURELY', 'SURVEY', 'SWITCH', 'SYMBOL', 'SYSTEM',
  'TACKLE', 'TAKING', 'TALENT', 'TARGET', 'TAUGHT', 'TEMPLE', 'TENANT', 'TENDER', 'TENNIS', 'TENSION',
  'THANKS', 'THEORY', 'THIRTY', 'THOMAS', 'THOUGH', 'THREAT', 'THROWN', 'TICKET', 'TIMBER', 'TIMING',
  'TISSUE', 'TOWARD', 'TREATY', 'TRIBAL', 'TRYING', 'TURKEY', 'TURNED', 'TWELVE', 'TWENTY', 'UNABLE',
  'UNIQUE', 'UNITED', 'UNLIKE', 'UPDATE', 'UPWARD', 'URGENT', 'USEFUL', 'VALLEY', 'VARIED', 'VICTIM',
  'VIEWER', 'VILLAGE', 'VISION', 'VOLUME', 'WALKER', 'WANTED', 'WEALTH', 'WEAPON', 'WEEKLY', 'WEIGHT',
  'WHOLLY', 'WICKED', 'WIDELY', 'WILLING', 'WILSON', 'WINDOW', 'WINNER', 'WINTER', 'WISDOM', 'WITHIN',
  'WONDER', 'WOODEN', 'WORKER', 'WRIGHT', 'WRITER', 'YELLOW',
  // Gaming terms
  'ACTION', 'ATTACK', 'BATTLE', 'CASTLE', 'COMBAT', 'DAMAGE', 'DEFEAT', 'DEFEND', 'DUNGEON', 'HEALTH',
  'KNIGHT', 'PLAYER', 'POTION', 'PUZZLE', 'SHIELD', 'STRIKE', 'SUMMON', 'WEAPON', 'WIZARD',
  // Longer gaming-specific terms from puzzles
  'SCYTHE', 'TICKET', 'ARKHAM', 'MYTHOS', 'MEEPLE',
]);

// 7+ letter words (for longer puzzles)
const LONGER_WORDS = new Set([
  'PANDEMIC', 'SPLENDOR', 'WINGSPAN', 'WYRMSPAN', 'MONOPOLY', 'CARCASSONNE', 'DOMINION',
  'AGRICOLA', 'TWILIGHT', 'BETRAYAL', 'GLOOMHAVEN', 'ADVENTURE', 'STRATEGY', 'KEYFORGE',
]);

// Combine all word lists
const VALID_WORDS = new Set([
  ...FOUR_LETTER_WORDS,
  ...FIVE_LETTER_WORDS,
  ...SIX_LETTER_WORDS,
  ...LONGER_WORDS,
]);

/**
 * Check if a word is in the valid words dictionary
 * @param word The word to validate
 * @returns true if the word is valid, false otherwise
 */
export function isWordInDictionary(word: string): boolean {
  return VALID_WORDS.has(word.toUpperCase());
}

/**
 * Get the size of the dictionary
 */
export function getDictionarySize(): number {
  return VALID_WORDS.size;
}
